import { render, staticRenderFns } from "./ViewWebTV.vue?vue&type=template&id=6450c513&scoped=true&"
import script from "./ViewWebTV.vue?vue&type=script&lang=ts&"
export * from "./ViewWebTV.vue?vue&type=script&lang=ts&"
import style0 from "./ViewWebTV.vue?vue&type=style&index=0&id=6450c513&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6450c513",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
